import React from "react";

const InfoIcon = ({ color = "#5D5D5D", width="12", height="12" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83333 0C2.61333 0 0 2.61333 0 5.83333C0 9.05333 2.61333 11.6667 5.83333 11.6667C9.05333 11.6667 11.6667 9.05333 11.6667 5.83333C11.6667 2.61333 9.05333 0 5.83333 0ZM6.41667 8.75H5.25V5.25H6.41667V8.75ZM6.41667 4.08333H5.25V2.91667H6.41667V4.08333Z"
        fill={color}
      />
    </svg>
  );
};

export default InfoIcon;
